import { LevelSpecification } from '../../LevelSpecification';
import { TechnicalPremiseSection } from '../../../../granulometry/sections/technicalPremiseSections/TechnicalPremiseSection';

export const getLevelTechnicalPermiseSections = (
  levelSpecification: LevelSpecification
): TechnicalPremiseSection[] => levelSpecification.technicalPremiseSections || [];
